import { rootApi } from '../rootApi';

export const collectionReportApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getCollectionReport: builder.query({
            query: ({ DealerCode = null, Year = null, Currency = null } = {}) => {
                const params = new URLSearchParams();
                if (DealerCode) params.append('DealerCode', DealerCode);
                if (Year != null && Year !== '') params.append('Year', Year);
                if (Currency) params.append('Currency', Currency);
                const qs = params.toString();
                return {
                    url: `v1/CreditCard/collection-report${qs ? `?${qs}` : ''}`,
                    method: 'GET'
                };
            },
            transformResponse: (response) => ({
                rows: response?.data?.rows || [],
                grandTotals: response?.data?.grandTotals || []
            }),
            providesTags: ['CollectionReport']
        }),

        exportCollectionReport: builder.query({
            query: ({ DealerCode = null, Year = null, Currency = null, CompressionType = null, languageId = null } = {}) => {
                const params = new URLSearchParams();
                if (DealerCode) params.append('DealerCode', DealerCode);
                if (Year != null && Year !== '') params.append('Year', Year);
                if (Currency) params.append('Currency', Currency);
                if (CompressionType != null) params.append('CompressionType', CompressionType);
                if (languageId != null) params.append('languageId', languageId);
                const qs = params.toString();
                return {
                    url: `v1/CreditCard/collection-report-export${qs ? `?${qs}` : ''}`,
                    method: 'GET'
                };
            },
            transformResponse: (response) => {
                const data = response?.data ?? {};
                return {
                    fileBase64: data.fileBase64,
                    fileName: data.fileName,
                    contentType: data.contentType,
                    isCompressed: data.isCompressed
                };
            }
        })
    })
});

export const { useGetCollectionReportQuery, useLazyExportCollectionReportQuery } = collectionReportApi;
